import { connect } from "react-redux";

import { actions as recaptchaActions } from "../recaptcha";

import ModalFind from "./ModalFind.view";

const mapStateToProps = state => ({
  attribution: state.analytics.attribution,
  emailOptIn: state.emailOptIn,
  recaptchaLoaded: state.recaptchaLoaded,
  user: state.login.user,
});

const mapDispatchToProps = dispatch => ({
  requestRecaptchaToken: action => dispatch(recaptchaActions.execute(action)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalFind);
